import type { FC } from 'react';
import type { InsiderTransation } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';
import {
  Roles,
  TransactionValue,
} from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import {
  TransactionColumn,
  TransactionTypePositioned,
  EntityColumn,
  InsiderTradingTable,
} from './styled';
export interface InsiderTradingDataTableProps {
  data: InsiderTransation[];
  uniqueSymbol: string;
}

const InsiderTradingDataTable: FC<InsiderTradingDataTableProps> = ({
  data,
  uniqueSymbol,
}) => (
  <InsiderTradingTable
    data-cy-id="insider-trading-table"
    columnWidths="0.7,1.3,1,0.6,0.6,0.6,0.6"
    columnTextAlignments="l,l,l,l,l,r,r"
  >
    <caption>
      {uniqueSymbol} Recent Insider Transactions by Companies or Individuals
    </caption>
    <thead>
      <tr>
        <th>Date</th>
        <th>Value</th>
        <th>Name</th>
        <th>Entity</th>
        <th>Role</th>
        <th>Shares</th>
        <th>Max Price</th>
      </tr>
    </thead>
    <tbody>
      {data.map((n, i) => (
        <tr key={`InsiderTradingDataTableRow-${n.ownerName}-${n.shares}-${i}`}>
          <td>{n.filingDate}</td>
          <TransactionColumn>
            <TransactionTypePositioned type={n.transactionType}>
              {n.transactionType}
            </TransactionTypePositioned>
            <TransactionValue type={n.transactionType}>
              {n.transactionValue}
            </TransactionValue>
          </TransactionColumn>
          <td>{n.ownerName}</td>
          <EntityColumn>
            <span>{n.ownerType}</span>
          </EntityColumn>
          <td>
            <Roles boardTitle={n.boardTitle} teamTitle={n.teamTitle} />
          </td>
          <td>{n.shares}</td>
          <td>{n.priceMax}</td>
        </tr>
      ))}
    </tbody>
  </InsiderTradingTable>
);

export default InsiderTradingDataTable;
